import { put, takeLatest, call } from 'redux-saga/effects';

import NewsPage from '@interfaces/news-page';
import { redirectToNotFound } from 'client/helpers/redirectTo';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchNewsPage(action: any) {
    try {
        const { page } = action.payload;
        const data: NewsPage = yield call(service.fetchNewsPage, page);

        yield put(actions.fetchNewsPageSuccess(data));
    } catch (error) {
        yield put(actions.fetchNewsPageError(error.message));
    }
}

function* fetchNews(action: any) {
    try {
        const { slug } = action.payload;
        const data: NewsPage = yield call(service.fetchNews, slug);

        yield put(actions.fetchNewsSuccess(data));
    } catch (error) {
        yield put(actions.fetchNewsError(error.message));
        yield put(redirectToNotFound());
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_NEWS_PAGE, fetchNewsPage);
    yield takeLatest(types.FETCH_NEWS, fetchNews);
}
